import {
    useEffect,
    useState,
} from 'react';
import {
    Container,
} from './styled';
import {
    FaLock,
    FaLockOpen
} from "react-icons/fa";
import { Switch } from 'react-switch-input';

export function AccessLevelAction(props) {

    const { access, onChange, initialValue } = props;
    const [switchChecked, setSwitchChecked] = useState(initialValue);

    useEffect(() => {
        if (access?.name === "MEUS") {
            setSwitchChecked(true)
        } else (
            setSwitchChecked(initialValue)
        )
    }, [initialValue])

    return (
        <Container lockOpen={switchChecked}>
            <div>
                <div>
                    <span>
                        {access?.abreviatura}
                    </span>
                </div>
                <div>
                    {access?.descricao}
                </div>
            </div>
            <div>
                {<FaLock
                    className={(switchChecked) ? 'opacity--' : ' '}
                />}
                <Switch
                    name={access?.name}
                    checked={switchChecked}
                    onChange={() => {
                        if (access?.name !== "MEUS") {
                            setSwitchChecked(!switchChecked)
                        }
                        onChange(access?.name);
                    }}
                />
                {<FaLockOpen
                    className={`faLockOpen ${!(switchChecked) ? 'opacity--' : ' '}`}
                />}
            </div>
        </Container>
    )
}